import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { MatchLeadViewType } from './MatchLeadState';
import {
    MatchLeadViewToggleButton,
    MatchLeadViewToggleTrack,
    MatchLeadViewToggleWrapper,
    MatchLeadWatchLiveIcon,
} from './MatchLeadViewToggle.style';

interface MatchLeadViewTogglePropsType {
    activeView: MatchLeadViewType;
    onChange: (view: MatchLeadViewType) => void;
}

export const MatchLeadViewToggle = observer(
    'MatchLeadViewToggle',
    ({ activeView, onChange }: MatchLeadViewTogglePropsType) => {
        return (
            <MatchLeadViewToggleWrapper data-test='match-lead-view-toggle'>
                <MatchLeadViewToggleTrack>
                    <MatchLeadViewToggleButton
                        type='button'
                        isActive={activeView === 'overview'}
                        onClick={(): void => onChange('overview')}
                        data-test='match-lead-view-overview'
                    >
                        <I18n
                            langKey='eventStream.overview'
                            defaultText='Overview'
                        />
                    </MatchLeadViewToggleButton>
                    <MatchLeadViewToggleButton
                        type='button'
                        isActive={activeView === 'watchLive'}
                        onClick={(): void => onChange('watchLive')}
                        data-test='match-lead-view-watch-live'
                    >
                        <MatchLeadWatchLiveIcon />
                        <I18n
                            langKey='eventStream.watchLive'
                            defaultText='Watch Live'
                        />
                    </MatchLeadViewToggleButton>
                </MatchLeadViewToggleTrack>
            </MatchLeadViewToggleWrapper>
        );
    }
);
